import { extname } from "node:path";

/**
 * File extensions that replay treats as binary. Binary files are skipped
 * during merge — no diff3, no patch_content extraction, no theirs_snapshot.
 *
 * Covers images, documents, archives, fonts, media, databases, and
 * compiled artifacts. Detection is extension-based (not magic-byte) — fast
 * and good enough for SDK-generation outputs.
 */
export const BINARY_EXTENSIONS: ReadonlySet<string> = new Set([
    ".png",
    ".jpg",
    ".jpeg",
    ".gif",
    ".bmp",
    ".ico",
    ".webp",
    ".svg",
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".zip",
    ".gz",
    ".tar",
    ".bz2",
    ".7z",
    ".rar",
    ".jar",
    ".war",
    ".ear",
    ".class",
    ".exe",
    ".dll",
    ".so",
    ".dylib",
    ".o",
    ".a",
    ".woff",
    ".woff2",
    ".ttf",
    ".eot",
    ".otf",
    ".mp3",
    ".mp4",
    ".avi",
    ".mov",
    ".wav",
    ".flac",
    ".sqlite",
    ".db",
    ".pyc",
    ".pyo",
    ".DS_Store",
]);

export function isBinaryFile(filePath: string): boolean {
    const ext = extname(filePath).toLowerCase();
    return BINARY_EXTENSIONS.has(ext);
}
